"use client";

import Script from "next/script";
import { useEffect, useState } from "react";

// eslint-disable-next-line regexp/no-unused-capturing-group
const appleRegex = /(iPad|iPhone|iPod|Macintosh)/i;

const ScrollbarScript = () => {
  const [isAppleOs, setIsAppleOs] = useState(false);
  useEffect(() => {
    setIsAppleOs(appleRegex.test(window.navigator.userAgent.toLowerCase()));
  }, []);

  return (
    <Script id="scrollbar">
      {!isAppleOs &&
        `
      document.head.insertAdjacentHTML("beforeend",\`
        <style>
          * {
            scrollbar-color: rgb(31 31 35 / 0.25) rgb(31 31 35 / 0.1);
          }

          *::-webkit-scrollbar {
            width: 0.5rem/* 8px */;
            height: 0.5rem/* 8px */;
            visibility: hidden;
          }

          *::-webkit-scrollbar-track {
            /*background-color: transparent;*/
            background-color: rgb(31 31 35 / 0.1);
          }

          *::-webkit-scrollbar-thumb {
            border-radius: 1rem /* 16px */;
            background-color: rgb(31 31 35 / 0.25);
          }

          ::-webkit-scrollbar-thumb:hover {
            background-color: rgb(31 31 35 / 0.4);
          }
        </style>
      \`)
  `}
    </Script>
  );
};

export default ScrollbarScript;
